<template>
  <div>
    <template v-if="state != '11'">

        <el-select v-model="form.state_type_id" filterable
                   class="border-left rounded-left border-info"
                   @change="send(form.state_type_id)">
            <el-option v-for="option in state_types" :key="option.id" :value="option.id"
                       :label="option.description"></el-option>
        </el-select>

    </template>
  </div>
</template>

<script>
export default {
  props: ['state', 'id'],
  data() {
    return {
      resource: 'order-notes',
      form: {},
      state_types: [
        {id:'01', description: 'Pendiente', class: 'btn-warning'},
        {id:'03', description: 'Por Entregar', class: 'btn-info'},
        {id:'05', description: 'Entregado', class: 'btn-success'},
        {id:'07', description: 'Sin receta', class: 'btn-secondary'},
        {id:'09', description: 'Con receta', class: 'btn-warning'},
        // {id:'11', description: 'Anulado', class: 'btn-danger'},
        {id:'13', description: 'En producción', class: 'btn-primary'}
      ],
    }
  },
  created() {
    this.initForm()
  },
  methods: {
    initForm() {
      this.form.id = this.id
      this.form.state_type_id = this.state
    },
    send(id) {
      this.form.id = this.id
      this.form.state_type_id = id

      this.$http.post(`${this.resource}/update/state`, this.form)
        .then(response => {
          if (response.data.success) {
            this.$message.success(response.data.message)
            this.$eventHub.$emit('reloadData')
          } else {
            this.$message.error('No se guardaron los cambios')
          }
        })
        .catch(error => {
          console.log(error)
        })
        this.form.state_type_id = this.form.state_type_id
      this.reload()
    },
    reload(){
      this.$eventHub.$emit('reloadData')
    }
  }
}
</script>